import React from 'react';
import { Link } from 'react-router-dom';

const Privacy = () => {
  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '40px 20px', color: '#e5e5e5', fontFamily: 'sans-serif' }}>
      
      <div style={{ marginBottom: '40px' }}>
        <Link to="/" style={{ 
          display: 'inline-flex', 
          alignItems: 'center', 
          gap: '8px', 
          color: '#a0a0a0', 
          textDecoration: 'none', 
          fontSize: '0.9rem',
          fontWeight: 'bold',
          padding: '8px 16px',
          backgroundColor: '#1a1a1a',
          borderRadius: '8px',
          border: '1px solid #333',
          transition: 'all 0.2s ease-in-out'
        }}
        onMouseOver={(e) => { e.currentTarget.style.color = '#ef4444'; e.currentTarget.style.borderColor = '#ef4444'; }}
        onMouseOut={(e) => { e.currentTarget.style.color = '#a0a0a0'; e.currentTarget.style.borderColor = '#333'; }}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <line x1="19" y1="12" x2="5" y2="12"></line>
            <polyline points="12 19 5 12 12 5"></polyline>
          </svg>
          Back to peekit.
        </Link>
      </div>

      <h1>Privacy Policy for peekit.</h1>
      <p style={{ color: '#a0a0a0' }}>Last Updated: April 2026</p>

      <h3>1. Data We Collect</h3>
      <p>We collect the following information to provide our services:</p>
      <ul>
        <li><strong>Steam ID:</strong> To identify your profile and aim statistics.</li>
        <li><strong>Email Address:</strong> To send you training reminders and system updates via Resend.</li>
        <li><strong>Usage Data:</strong> Information on how you interact with our training modules.</li>
      </ul>

      <h3>2. How We Use Your Data</h3>
      <p>Your data is used to maintain your profile, track your progress, and communicate with you. We do not sell your personal data to third parties.</p>

      <h3>3. Data Storage & Security</h3>
      <p>Your data is stored securely using <strong>Google Cloud/Firebase</strong> infrastructure. We implement industry-standard security measures to protect your information.</p>

      <h3>4. Third-Party Services</h3>
      <p>We use third-party providers to operate: <strong>Resend</strong> (for emails) and <strong>Vercel</strong> (for hosting). These providers have access to your data only to perform specific tasks on our behalf.</p>

      <h3>5. Your Rights</h3>
      <p>You have the right to access, correct, or request the deletion of your personal data. To do so, please contact us at no-reply@peekitapp.com.</p>
    </div>
  );
};

export default Privacy;